import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import * as fromActions from './slice';
import { InvestmentOrderService } from './investment-order.service';
import { ApiOrderCreationStatusEnum } from '@qvs/core';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectOrderById } from './slice';

@Injectable()
export class InvestmentOrderEffects {
  loadInvestmentOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadInvestmentOrders),
      concatMap((action) =>
        this.investmentOrderService.loadInvestmentOrders(action.payload.maxResults).pipe(
          map((investmentOrders) =>
            investmentOrders.filter(
              (investmentOrder) =>
                !(
                  investmentOrder.apiOrderCreationStatus === ApiOrderCreationStatusEnum.AUTHORIZATION_EXPIRED ||
                  investmentOrder.apiOrderCreationStatus === ApiOrderCreationStatusEnum.PENDING_AUTHORIZATION ||
                  investmentOrder.apiOrderCreationStatus === ApiOrderCreationStatusEnum.WAITING_AUTHORIZATION_CONFIRMATION
                )
            )
          ),
          switchMap((investmentOrders) =>
            of(fromActions.loadInvestmentOrdersSuccess(), fromActions.setInvestmentOrders({ entities: investmentOrders }))
          ),
          catchError(() => of(fromActions.loadInvestmentOrdersFailure()))
        )
      )
    )
  );

  loadInvestmentOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadInvestmentOrder),
      concatMap((action) =>
        this.investmentOrderService.loadInvestmentOrder(action.payload.orderId).pipe(
          switchMap((investmentOrder) =>
            of(fromActions.loadInvestmentOrderSuccess(), fromActions.upsertInvestmentOrder({ entity: investmentOrder }))
          ),
          catchError(() => of(fromActions.loadInvestmentOrderFailure()))
        )
      )
    )
  );

  loadInvestmentOrderIfNotLoadedYet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadInvestmentOrderOnlyIfNotLoadedYet),
      concatLatestFrom((action) => this.store.select(selectOrderById(action.orderId))),
      switchMap(([{ orderId }, order]) => {
        if (order) {
          return EMPTY;
        }
        return of(fromActions.loadInvestmentOrder({ orderId }));
      })
    )
  );

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly investmentOrderService: InvestmentOrderService
  ) {}
}
